




















































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getBindinglList, classEdit, classDel } from '@/api/admin'
import conFirm from './../confirm.vue'
import bindGreat from './bindingcreat.vue'

@Component({
  components: {
    conFirm,
    bindGreat
  }
})
export default class Binding extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  lang = {}
  totalClass = 0

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  created() {
    this.lang = this.i18n.vBinding
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.classname,
        className: 'colName',
        dataIndex: 'name'
      },
      {
        title: this.i18n.vStudentList.stuNum,
        className: 'wid185',
        dataIndex: 'bind_client_num'
      },

      {
        title: lang.creattime,
        className: 'wid185',
        dataIndex: 'create_time'
        // scopedSlots: { customRender: 'subjectid' }
      },
      {
        title: this.i18n.resource.operation,
        dataIndex: 'operation',
        className: 'texcenter wid370',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.getType()
  }
  async getType() {
    try {
      const { data } = await getCateList()
      // console.log('获取学科接口', data)
      const resTypeList: any = []
      const dsubject: any = []
      const phaseList: any = []
      const dphase: any = []
      const dresType: any = []

      data.res_type.map((item: any) => {
        dresType[item.id] = item.name
        resTypeList.push(item)
      })
      data.phase.map((item: any) => {
        dphase[item.id] = item.name
        phaseList.push(item)
        item.subject.map((subject: any) => {
          dsubject[subject.id] = subject.name
        })
      })

      this.resTypeList = resTypeList
      this.dsubject = dsubject
      this.dphase = dphase
      this.dresType = dresType
      this.phaseList = phaseList
      this.fetch({
        page: 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await getBindinglList(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.totalClass = data.list ? data.list.length : 0
      this.pagination = pagination
    } catch (ex) {
      this.handleError(ex)
    }
  }
  cancelMod() {
    this.editVisible = false
    this.delVisible = false
  }
  addclassshow() {
    this.editItem = {}
    this.editVisible = true
  }
  editclassshow(item: any) {
    const ddd = Object.assign({}, item)
    ddd.name = ddd.name + ''
    this.editItem = ddd
    this.editVisible = true
  }
  delclassshow(item: any) {
    this.delItem = item
    this.delVisible = true
  }
  editbinding(item: any) {
    this.$router.push({
      name: 'bindingStudentList',
      params: { id: item.id + '', class: item.name }
    })
  }
  async addclass(name: any) {
    const itme: any = this.editItem
    const pdata: any = {
      class_id: itme.id || '',
      name: name + ''
    }
    try {
      const res = await classEdit(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.editVisible = false

      this.fetch({
        page: this.pagination.current || 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async delclass() {
    const itme: any = this.delItem
    const pdata: any = {
      class_id: itme.id || ''
    }
    try {
      const res = await classDel(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.delVisible = false
      let getPagination = 0
      if (this.totalClass == 1 && this.pagination.current != 1) {
        getPagination = this.pagination.current - 1
        this.pagination.current = getPagination
      } else if (this.totalClass > 1) {
        getPagination = this.pagination.current
      } else if (
        this.totalClass == 1 &&
        (!this.pagination.current || this.pagination.current == 1)
      ) {
        getPagination = 1
      }
      this.fetch({
        page: getPagination
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
